const TITLE = 'Getting Started'
const SUB_TITLE = 'Try these actions or voice commands'

export { TITLE, SUB_TITLE }
